import React, { createContext, useCallback, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

const UIContext = createContext();

const breakpoints = [
  { name: 'xl', value: 1280, index: 4 },
  { name: 'lg', value: 1024, index: 3 },
  { name: 'md', value: 768, index: 2 },
  { name: 'sm', value: 576, index: 1 },
  { name: 'xs', value: 0, index: 0 },
];

const UIProvider = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [breakpoint, setBreakpoint] = useState(false);
  const [ui, setUI] = useState({
    header: {
      isVisible: false,
      contentUnderHeader: false,
    },
  });

  const handleResize = useCallback(() => {
    const desktopBreakpointIndex = 3;
    const tabletBreakpointIndex = 2;
    const mobileBreakpointIndex = 1;

    let current;
    let currentIndex;
    let prev;

    for (const bp of breakpoints) {
      const queryMin = `(min-width: ${bp.value}px)`;
      const queryMax =
        (prev?.value && `(max-width: ${prev.value - 1}px)`) ||
        `(max-width: 100vw)`;

      if (window.matchMedia(`${queryMin} and ${queryMax}`).matches) {
        current = bp.name;
        currentIndex = bp.index;
      }

      prev = bp;
    }

    setBreakpoint({
      current,
      index: currentIndex,
      isDesktop: currentIndex >= desktopBreakpointIndex,
      isTabletOrSmaller: currentIndex < tabletBreakpointIndex,
      isMobile: currentIndex < mobileBreakpointIndex,
      width: window.innerWidth,
    });
  }, []);

  useEffect(() => {
    if (!window) {
      return;
    }

    handleResize(window);
  }, [handleResize]);

  useEffect(() => {
    if (!window) {
      return;
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [setBreakpoint, handleResize]);

  return (
    <UIContext.Provider
      value={{
        ui,
        setUI,
        menuOpen,
        setMenuOpen,
        breakpoint,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export { UIContext as default, UIProvider };

UIProvider.propTypes = {
  children: PropTypes.object,
};
